import { Component, Input, Output, EventEmitter, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { CarouselStep, CarouselSlideMultipleSteps, ScreenSizeEnums, StepOtherOption } from '../carousel.interfaces';

@Component({
  selector: 'csa-carousel-slider',
  templateUrl: './carousel-slider.component.html',
  styleUrls: ['./carousel-slider.component.scss'],
  standalone: false,
})
export class CarouselSliderComponent implements OnChanges {
  @ViewChild('matCarousel') matCarousel: any;
  @Output() changeSlideSwipe: EventEmitter<number> = new EventEmitter<number>();
  @Input() slides: CarouselStep[];
  @Input() slidesWithMultipleSteps: CarouselSlideMultipleSteps[];
  @Input() screenSize: ScreenSizeEnums;
  @Input() currentSlideIndex: number;
  @Input() mouseClick: Event;
  @Input() autoPlay: boolean;
  @Input() otherOptions: StepOtherOption[];
  screenSizesEnums = ScreenSizeEnums;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentSlideIndex && this.matCarousel && changes.mouseClick) {
      changes.currentSlideIndex.previousValue > changes.currentSlideIndex.currentValue ? this.moveLeft() : this.moveRight();
    }

    // Resets the carousel to the first slide
    const hasSlides = changes.slides && changes.slides.previousValue && changes.slides.currentValue;
    if (hasSlides && this.screenSize !== ScreenSizeEnums.LargeScreen && changes.slides.previousValue.length !== changes.slides.currentValue.length) {
      this.moveRight();
    }
  }

  handleChange(slideIndex: number) {
    this.changeSlideSwipe.emit(slideIndex);
  }

  private moveLeft(): void {
    if (this.matCarousel.carouselContainer.nativeElement.querySelectorAll('button').length >= 1) {
      this.matCarousel.carouselContainer.nativeElement.querySelectorAll('button')[0].click();
    }
  }

  private moveRight(): void {
    if (this.matCarousel.carouselContainer.nativeElement.querySelectorAll('button').length >= 1) {
      this.matCarousel.carouselContainer.nativeElement.querySelectorAll('button')[1].click();
    }
  }
}
